import React from "react";
import "./Hero.sass";

export default function Hero() {
  return (
    <div className="wage">
      <div className="wage-bg"></div>
      <div className="wage-container">
        <h1 className="wage-title">THE WAGE CAGE WAR</h1>
        <button className="wage-play">PLAY</button>
        <h2 className="wage-marketplace not-mobile">GO TO MARKETPLACE</h2>
      </div>
    </div>
  );
}
